define.alias("shared/components/shared/credentials/grant-new-permissions", "auth/components/shared/credentials/grant-new-permissions");